import constants from '@/constant'
import socketHelper from '@/helpers/socket/socket-helper'

const updateSlideActiveAction = ({ commit }, payload) => {
  commit('updateSlideActive', payload)
}

const updateSlideByIdAction = ({ commit }, payload) => {
  commit('updateSlideById', payload)
}

const setSlideActiveAction = ({ commit, state }, payload) => {
  payload = payload || {}
  if (!payload.activeTab) {
    payload.activeTab = payload.type ? 2 : 1
  }

  payload.SlideOptions = payload.SlideOptions || []

  const slideTypes = [
    'bulletPoints',
    'multipleChoice',
    'pickAnswer',
    'imageChoice',
    'scale',
  ]

  const customDefaultSlideOptionsType = ['matchPairs', 'correctOrder']

  // Create default SlideOptions
  if (slideTypes.includes(payload.type) &&
      !customDefaultSlideOptionsType.includes(payload.slideType) &&
      payload.SlideOptions.length === 0) {
    payload.SlideOptions = [
      { index: 1, order: 1 },
      { index: 2, order: 2 },
      { index: 3, order: 3 },
    ]
  }

  if (payload.type === 'voiceQA' && payload.SlideOptions.length === 0) {
    payload.SlideOptions = [
      { index: 1, order: 1, title: 'Your name' },
      { index: 2, order: 2, title: 'Your sitting area' },
    ]
  }

  if (payload.type === 'ideas') {
    payload.limitChoice = Math.min(constants.MAX_VOTE_IDEAS, payload.limitChoice)
    payload.limitChoice = Math.max(constants.MIN_VOTE_IDEAS, payload.limitChoice)
  } else {
    payload.limitChoice = Math.max(2, payload.limitChoice || 2)
  }

  if (payload.type === 'bulletPoints') {
    payload.bulletPoints = payload.bulletPoints || []
  }

  if (state.route.name === 'PresentationDetail' &&
    state.lastSlideActiveId &&
    payload.id &&
    state.lastSlideActiveId !== payload.id
  ) {
    socketHelper.leaveRoomSlide(state.presentation.uniqueAccessCode, state.lastSlideActiveId)
    socketHelper.joinRoomSlide(state.presentation.uniqueAccessCode, payload.id)
  }

  commit('setSlideActive', payload)
}

const checkSlideMovingDirectionAction = ({ commit }, slideActiveId) => {
  commit('checkSlideMovingDirection', slideActiveId)
}

export default {
  // use action which has suffix 'Action'
  updateSlideActiveAction,
  updateSlideActive: updateSlideActiveAction,
  updateSlideByIdAction,
  setSlideActiveAction,
  setSlideActive: setSlideActiveAction,
  checkSlideMovingDirectionAction,
}
